import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Daundbusrentalserice() {



  const cardData =
  {
    keyword: 'Daund Bus Rental Service',
    heading: 'Sanavi Travels: Daund Bus Rental Service',
    headingDescription: 'Sanavi Travels offers reliable Daund Bus Rental Service, providing safe, comfortable, and spacious transportation for families, groups, corporate trips, school excursions, and pilgrimage journeys. Our fleet of well-maintained AC and non-AC buses, mini buses, and luxury coaches ensures smooth rides, ample seating, and sufficient luggage space for a hassle-free travel experience. With professional drivers, flexible one-way and round-trip rental packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Daund, Pune, and nearby areas, making it ideal for local travel, outstation trips, corporate events, and group tours. Choose Sanavi Travels for trusted bus rental services in Daund, delivering comfort, safety, and a seamless travel experience for every occasion.',

    top: 'Top Places to Visit in Daund with Sanavi Travels',


"topPlaces": [
  {
    "title": "Bhigwan Bird Sanctuary",
    "description": "Located near Daund, Bhigwan Bird Sanctuary is a paradise for bird watchers, especially during the migratory season. Visitors can spot flamingos, pelicans, storks, and other waterbirds. Early morning boat rides offer the best viewing experience."
  },
  {
    "title": "Ujani Dam Backwaters",
    "description": "The backwaters of Ujani Dam, situated close to Daund, provide a peaceful setting for picnics, photography, and birdwatching. The expansive water body and surrounding greenery make it an ideal spot for relaxation."
  },
  {
    "title": "Shri Siddheshwar Temple",
    "description": "Shri Siddheshwar Temple is a significant religious site in Daund, dedicated to Lord Shiva. Devotees visit throughout the year for rituals, prayers, and festivals, enjoying the temple's serene spiritual atmosphere."
  },
  {
    "title": "Daund Railway Junction",
    "description": "Daund Railway Junction is an important transport hub connecting Pune, Solapur, and southern India. The junction facilitates travel and trade, making it vital to the region’s connectivity."
  },
  {
    "title": "Bhigwan Wetlands",
    "description": "The wetlands near Bhigwan, close to Daund, are home to diverse bird species and rich biodiversity. Nature enthusiasts and photographers often explore this area for its wildlife and scenic landscapes."
  },
  {
    "title": "Local Sugarcane Fields",
    "description": "Daund is surrounded by fertile agricultural lands, particularly sugarcane plantations. Visitors can witness traditional farming practices and the rural lifestyle of Maharashtra."
  },
  {
    "title": "Village Temples and Wadis",
    "description": "The villages around Daund have several small temples and wadi shrines reflecting traditional religious practices. These sites are often centers for local festivals and community gatherings."
  },
  {
    "title": "Indapur Road Countryside",
    "description": "The scenic countryside along Indapur Road features farmland, canals, and open fields. It is ideal for relaxed drives, photography, and experiencing rural Maharashtra."
  },
  {
    "title": "Weekly Local Markets",
    "description": "Daund’s weekly markets are lively spaces where locals sell fresh produce, grains, livestock, and handicrafts. Visitors can experience the vibrancy of rural commerce and community life."
  },
  {
    "title": "Pilgrimage Transit Point",
    "description": "Daund is strategically located near religious destinations like Pandharpur and Bhigwan, making it a convenient stop for pilgrims traveling to temples and spiritual sites."
  }
]
,



"services": [
    {
      "name": "Daund Bus Rental Service",
      "description": "Daund Bus Rental Service offers reliable and comfortable transportation solutions for all types of travel needs. Whether it's a wedding, corporate outing, tourist trip, or group travel, our buses are well-maintained, spacious, and equipped to ensure a smooth journey across Daund and beyond."
    },
    {
      "name": "Bus Hire Daund",
      "description": "Bus Hire in Daund provides flexible rental options for local, outstation, and event travel. With experienced drivers, modern buses, and customizable itineraries, it is ideal for family trips, group tours, corporate travel, and special occasions."
    },
    {
      "name": "AC Bus Rental Daund",
      "description": "AC Bus Rental in Daund offers air-conditioned buses for comfortable and refreshing travel. Perfect for long-distance trips, family outings, corporate tours, and tourist travel, these buses combine comfort, safety, and reliability."
    },
    {
      "name": "Luxury Bus Rental Daund",
      "description": "Luxury Bus Rental Daund provides premium buses for high-end travel experiences. Equipped with modern amenities, plush seating, and professional chauffeurs, these buses are ideal for weddings, corporate events, VIP tours, and special group travel."
    },
    {
      "name": "Wedding Bus Daund",
      "description": "Wedding Bus Daund specializes in guest transportation for weddings and related events. With spacious seating, comfortable interiors, and punctual service, it ensures a smooth and memorable journey for wedding guests, family members, and bridal parties."
    },
    {
      "name": "Corporate Bus Daund",
      "description": "Corporate Bus Daund offers professional transportation solutions for businesses, offices, and IT companies. Ideal for employee commutes, corporate outings, seminars, and events, it ensures reliable, safe, and comfortable travel for your team."
    },
    {
      "name": "Outstation Bus Daund",
      "description": "Outstation Bus Daund provides long-distance travel solutions for trips across Maharashtra and neighboring states. With well-maintained buses, experienced drivers, and flexible itineraries, it is perfect for family tours, religious trips, and group excursions."
    },
    {
      "name": "Affordable Bus Daund",
      "description": "Affordable Bus Daund offers cost-effective bus rental solutions for individuals, families, and groups. While maintaining high standards of safety and comfort, the service ensures travel within budget, making it ideal for weddings, parties, and corporate events."
    },
    {
      "name": "Chauffeur Driven Bus Daund",
      "description": "Chauffeur Driven Bus Daund provides a stress-free travel experience with professional drivers handling navigation, traffic, and schedules. Perfect for corporate trips, weddings, and group travel, the service prioritizes safety, comfort, and timely arrivals."
    },
    {
      "name": "Best Bus Rental Daund",
      "description": "Best Bus Rental Daund guarantees top-quality buses, punctual service, and professional drivers for all types of travel. Catering to weddings, corporate events, group tours, and long-distance trips, it ensures a reliable and comfortable journey every time."
    },
    {
      "name": "Tourist Bus Daund",
      "description": "Tourist Bus Daund specializes in travel for sightseeing, hill stations, and tourist attractions. With spacious seating, safety measures, and flexible itineraries, it is ideal for families, groups, and tourists exploring Pune and nearby regions."
    },
    {
      "name": "Group Travel Bus Daund",
      "description": "Group Travel Bus Daund provides efficient and organized transportation for families, friends, corporate groups, and social gatherings. Offering spacious seating, comfort, and professional drivers, it ensures seamless travel for groups of all sizes."
    },
    {
      "name": "Online Bus Booking Daund",
      "description": "Online Bus Booking Daund allows customers to reserve buses easily through a digital platform. With instant confirmation, multiple bus options, and flexible scheduling, it simplifies planning for weddings, corporate events, tourist trips, and long-distance travel."
    },
    {
      "name": "Event Bus Daund",
      "description": "Event Bus Daund offers dedicated transportation for weddings, parties, conferences, and corporate events. With comfortable buses, professional drivers, and customizable itineraries, it ensures punctuality and a hassle-free travel experience for all attendees."
    },
    {
      "name": "Daund Travel Bus",
      "description": "Daund Travel Bus provides reliable and comfortable travel solutions for local, outstation, and special events. Combining affordability, safety, and luxury, it caters to families, corporate groups, tourists, and wedding guests for a smooth and memorable journey."
    }
  ],
  "tableData": [
    ["Daund Bus Rental Service", "Bus Hire Daund"],
    ["AC Bus Rental Daund", "Luxury Bus Rental Daund"],
    ["Wedding Bus Daund", "Corporate Bus Daund"],
    ["Outstation Bus Daund", "Affordable Bus Daund"],
    ["Chauffeur Driven Bus Daund", "Best Bus Rental Daund"],
    ["Tourist Bus Daund", "Group Travel Bus Daund"],
    ["Online Bus Booking Daund", "Event Bus Daund"],
    ["Daund Travel Bus", "—"]
  ]
,



"whychoose": [
  {
    "WhyChooseheading": "Daund Bus Rental Service with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable bus rental services in Daund, ideal for group outings, family trips, corporate events, school excursions, and local or outstation travel."
  },
  {
    "WhyChooseheading": "Wide Range of Well‑Maintained Buses",
    "WhyChoosedescription": "Choose from a variety of clean, air‑conditioned, and regularly serviced buses to ensure a smooth and enjoyable journey for your travel needs."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, punctual, and familiar with local and intercity routes, providing safe and timely transportation."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear and upfront pricing for all bus rentals in Daund, including fuel, tolls, and driver allowances with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, route planning, and any last‑minute changes for your bus rental service."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, or customized bus rental packages based on your travel schedule and group requirements in Daund."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for bus rentals in Daund."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Daund?',
    answer: 'Yes, Sanavi Travels offers dependable bus rental services in Daund for group travel, corporate events, school trips, and outstation journeys.'
  },
  {
    question: 'How can I book a bus rental in Daund?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for rental in Daund?',
    answer: 'Sanavi Travels provides a range of buses including mini buses, 20‑seater, 32‑seater, 45‑seater, and 50‑seater buses, depending on your group size and needs.'
  },
  {
    question: 'Are the buses well‑maintained and air‑conditioned?',
    answer: 'Yes, all our buses are clean, air‑conditioned, and regularly serviced for a comfortable travel experience.'
  },
  {
    question: 'Are drivers experienced with local and intercity routes?',
    answer: 'Yes, our drivers are professional, licensed, and familiar with both local Daund routes and intercity travel paths.'
  },
  {
    question: 'Can I rent a bus for a few hours or a full day?',
    answer: 'Absolutely. We offer flexible hourly, half‑day, full‑day, and customized rental packages to suit your travel needs.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before departure to ensure passenger safety.'
  },
  {
    question: 'What payment options are available for Daund bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the bus rental journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your bus trip in Daund.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ajay Patil',
    feedback: 'Rented a bus in Daund for our family outing. Comfortable and clean bus with a professional driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha Kulkarni',
    feedback: 'Excellent bus rental service in Daund. The entire experience was smooth, and the support team was very helpful.',
    rating: 5
  }
];































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Daund Bus Rental Service - Sanavi Travels",
  "description": "Sanavi Travels offers Daund bus rental services including AC and luxury buses. Perfect for weddings, corporate travel, outstation trips, tourist trips, group travel, and events. Affordable and chauffeur-driven buses with online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "68"
  }
};






  return (
    <div>

<Helmet>
  <title>
    Daund Bus Rental Service | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Sanavi Travels offers Daund bus rental services including AC and luxury buses. Perfect for weddings, corporate travel, outstation trips, tourist trips, group travel, and events. Affordable and chauffeur-driven buses with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/118.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Daundbusrentalserice;